import { NavLink } from "react-router-dom";
import { Users, Plug, BellRing, ShieldCheck, LogOut, Sparkles, FileText, Zap, BarChart3, Target } from "lucide-react";
import { useAuth } from "@/lib/auth";

const NAV_NARWHAL = [
  { to: "/clients", label: "Clients", icon: Users, testId: "nav-clients" },
  { to: "/insights", label: "Insights", icon: Zap, testId: "nav-insights" },
  { to: "/ai-assistant", label: "Asistente IA", icon: Sparkles, testId: "nav-ai-assistant" },
  { to: "/ai-analytics", label: "Analista IA", icon: BarChart3, testId: "nav-ai-analytics" },
  { to: "/paid-analyst", label: "Analista Paid", icon: Target, testId: "nav-paid-analyst" },
  { to: "/reports-config", label: "Reportes", icon: FileText, testId: "nav-reports-config" },
  { to: "/integrations", label: "Integrations", icon: Plug, testId: "nav-integrations" },
  { to: "/alerts", label: "Alerts", icon: BellRing, testId: "nav-alerts" },
  { to: "/users", label: "Usuarios", icon: ShieldCheck, testId: "nav-users" },
];

export default function Sidebar() {
  const { user, logout, isNarwhal } = useAuth();
  const NAV = isNarwhal ? NAV_NARWHAL : [];
  return (
    <aside
      data-testid="sidebar"
      className="hidden md:flex flex-col fixed left-0 top-0 bottom-0 w-64 bg-slate-950 text-slate-200 z-30"
    >
      <div className="px-6 pt-7 pb-6 border-b border-white/5 flex items-center gap-3">
        <div className="h-10 w-10 rounded-md bg-white flex items-center justify-center overflow-hidden shrink-0">
          <img
            src="https://customer-assets.emergentagent.com/job_data-sync-49/artifacts/mjp9j70a_logo_narwhal_curvas_no_text.png"
            alt="Narwhal logo"
            className="h-9 w-9 object-contain"
          />
        </div>
        <div className="leading-tight">
          <div className="font-display text-base font-semibold text-white tracking-tight">Narwhal</div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-slate-500 font-medium">Agency Analytics</div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-5 space-y-0.5">
        {isNarwhal && (
          <div className="px-3 pb-2 text-[10px] uppercase tracking-[0.22em] text-slate-500 font-semibold">Workspace</div>
        )}
        {NAV.map(({ to, label, icon: Icon, testId }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testId}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
                isActive
                  ? "bg-white text-slate-900 font-medium shadow-sm"
                  : "text-slate-300 hover:text-white hover:bg-white/5"
              }`
            }
          >
            <Icon className="h-4 w-4" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-4 pb-5 pt-3 border-t border-white/5 space-y-2">
        {user && (
          <div className="px-1 pb-1">
            <div className="text-[10px] uppercase tracking-[0.18em] text-slate-500 font-semibold mb-0.5">Sesión</div>
            <div className="text-xs text-slate-200 font-medium truncate" title={user.full_name}>{user.full_name}</div>
            <div className="text-[10px] text-slate-500 truncate" title={user.email}>{user.email}</div>
          </div>
        )}
        <button onClick={logout} data-testid="logout-btn" className="w-full flex items-center gap-2 px-3 py-2 rounded-md text-xs text-slate-300 hover:text-white hover:bg-white/5 transition-colors">
          <LogOut className="h-3.5 w-3.5" /> Cerrar sesión
        </button>
      </div>
    </aside>
  );
}
